// ExportButton — secondary action button that opens the ExportModal.
// Replaces the disabled Export stub in ContractOverviewHeader.

import { useState } from "react";
import { Download } from "lucide-react";
import ExportModal from "./ExportModal";

interface ExportButtonProps {
  contractId: string;
}

export default function ExportButton({ contractId }: ExportButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="btn-secondary py-2 px-3 inline-flex items-center gap-1"
      >
        <Download className="h-4 w-4" aria-hidden="true" />
        Export
      </button>
      <ExportModal
        contractId={contractId}
        isOpen={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
